module.exports = "./images/main-vr-man-img@2x.png?8b0b97d5c826210c6ab1c3e962e30d78";


//////////////////
// WEBPACK FOOTER
// ./src/images/main-vr-man-img@2x.png
// module id = 23
// module chunks = 0